// @ts-ignore it is not error
import videoCallRespondent from './videoCallRespondent.ejs';

export default videoCallRespondent;
